import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { bindActionCreators } from 'redux';

import { Fab } from '@material-ui/core';

import * as PreviewStore from '../../app/store/PreviewStore';
import { InfoMessage } from '../../common/components';
import PreviewTaskContent from './components/PreviewTaskContent';
import { PREVIEW_TASK_RECEIVED } from '../../app/store/actions';
import { CommentIcon, CloseIcon, PrintIcon } from '../../common/icons';
import { headerHeight } from '../outside/components/Layout';
import PageLayout from './components/PageLayout';

const styles = theme => ({
    root: {
        paddingTop: theme.spacing(4),
    },
    commentFab: {
        position: 'absolute',
        right: 0 + theme.spacing(2),
        top: headerHeight + theme.spacing(2),
        zIndex: 101,

        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    printFab: {
        position: 'absolute',
        right: 0 + theme.spacing(2) + 70,
        top: headerHeight + theme.spacing(2),
        zIndex: 101,

        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
});

class PreviewTask extends React.Component {
    showPrint = () => {
        window.print();
    }

    render() {
        const {
            classes, translate, taskDetails, hasLoaded, showComments, toggleComments,
        } = this.props;

        const task = taskDetails;

        if (!task) {
            return hasLoaded ? (<InfoMessage messageKey="noContent" />) : null;
        }

        return (
            <PageLayout
                title={task.name}
                task={task}
                showComments={showComments}
                sideContent={(
                    <>
                        <Fab
                            onClick={toggleComments}
                            className={classes.commentFab}
                            color="primary"
                            title={showComments ? translate('taskCommenting.hideComments') : translate('taskCommenting.addOrShowComments')}
                        >
                            {showComments ? <CloseIcon /> : <CommentIcon />}
                        </Fab>
                        <Fab
                            onClick={this.showPrint}
                            className={classes.printFab}
                            color="primary"
                            title={translate('taskCommenting.print')}
                        >
                            <PrintIcon />
                        </Fab>
                    </>
                )}
            >
                <div className={classes.root}>
                    <PreviewTaskContent
                        task={task}
                    />
                </div>
            </PageLayout>
        );
    }
}

PreviewTask.propTypes = {
    classes: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    hasLoaded: PropTypes.bool.isRequired,
    toggleComments: PropTypes.func.isRequired,
    showComments: PropTypes.bool.isRequired,
    taskDetails: PropTypes.object,
};

PreviewTask.defaultProps = {
    taskDetails: null,
};

const mapStateToProps = (state, ownProps) => {
    const taskId = ownProps?.match?.params?.taskId;

    return {
        translate: getTranslate(state.localize),
        taskDetails: state.previewStore.details && state.previewStore.details[taskId],
        clientConfig: state.auth.clientConfig,
        hasLoaded: Boolean(state.previewStore.requests[`${PREVIEW_TASK_RECEIVED}/${taskId}`]
        && state.previewStore.requests[`${PREVIEW_TASK_RECEIVED}/${taskId}`].completed),
        showComments: state.previewStore.showComments,
    };
};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators(PreviewStore.actionCreators, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PreviewTask));
